import { render } from "./StudioInfoM.vue?vue&type=template&id=01a47e6b&scoped=true"
import script from "./StudioInfoM.vue?vue&type=script&lang=js"
export * from "./StudioInfoM.vue?vue&type=script&lang=js"

import "./StudioInfoM.vue?vue&type=style&index=0&id=01a47e6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a47e6b"]])

export default __exports__